import { useLang } from "@/lib/LanguageContext";

export default function LanguageToggle({ variant = "light" }) {
    const { lang, setLang } = useLang();

    const isDark = variant === "dark";
    const base =
        "text-[11px] tracking-[0.2em] uppercase px-2 py-1 border transition-colors";
    const activeCls = isDark
        ? "bg-[#F9F6F0] text-[#2D2824] border-[#F9F6F0]"
        : "bg-[#2D2824] text-[#F9F6F0] border-[#2D2824]";
    const idleCls = isDark
        ? "border-[#5C564D] text-[#D9D1C7] hover:border-[#F9F6F0]"
        : "border-[#D9D1C7] text-[#5C564D] hover:border-[#2D2824] hover:text-[#2D2824]";

    return (
        <div
            className="inline-flex items-center gap-1"
            role="group"
            aria-label="Language"
            data-testid="language-toggle"
        >
            <button
                onClick={() => setLang("en")}
                className={`${base} ${lang === "en" ? activeCls : idleCls}`}
                data-testid="lang-toggle-en"
                aria-pressed={lang === "en"}
            >
                EN
            </button>
            <button
                onClick={() => setLang("hi")}
                className={`${base} ${lang === "hi" ? activeCls : idleCls}`}
                data-testid="lang-toggle-hi"
                aria-pressed={lang === "hi"}
            >
                HI
            </button>
        </div>
    );
}
